let socket
let bc
export default {
  state: {
    messages: null,
    connect: false,
    count: 0,
  },
  getters: {
    SOCKET_MESSAGES: (s) => s.messages,
  },
  mutations: {
    setMessages: (s, list) => {
      s.messages = list
      localStorage.setItem('SOCKET_MESSAGES', list)
    },
    setConnect: (s, status) => (s.connect = status),
    setCount: (s, count) => (s.count = count),
  },
  actions: {
    SOCKET_CONNECT(ctx) {
      if (!ctx.state.connect && localStorage.getItem('token')) {
        let host = window.location.host.includes('localhost')
          ? 'dev.herbalifeacademy.ru'
          : window.location.host
        socket = new WebSocket(`wss://${host}/api/v3/events/socket`)
        bc = new BroadcastChannel('SOCKET_MESSAGES')
        socket.onopen = () => {
          socket.send(
            JSON.stringify({
              action: 'auth',
              token: localStorage.getItem('token'),
            })
          )
          ctx.commit('setConnect', true)
        }
        socket.onmessage = function (event) {
          if (!ctx.state.messages) {
            if (event.data && JSON.parse(event.data).slug) {
              ctx.commit('setMessages', JSON.parse(event.data))
              bc.postMessage(event.data)
            } else {
              bc.postMessage(null)
            }
          }
        }

        bc.onmessage = (event) => {
          if (!ctx.state.messages) {
            ctx.commit('setMessages', JSON.parse(event.data))
          }
        }

        socket.onclose = function (event) {
          if (event.wasClean) {
            console.log(
              `[close] Соединение закрыто чисто, код=${event.code} причина=${event.reason}`
            )
            ctx.commit('setConnect', false)
            bc.close()
            if (ctx.state.count < 5) {
              setTimeout(() => {
                ctx.dispatch('SOCKET_CONNECT')
                ctx.commit('setCount', ctx.state.count + 1)
              }, 2000)
            }
          } else {
            // например, сервер убил процесс или сеть недоступна
            // обычно в этом случае event.code 1006
            console.log('[close] Соединение прервано')
            ctx.commit('setConnect', false)
            bc.close()
            if (ctx.state.count < 5) {
              setTimeout(() => {
                ctx.dispatch('SOCKET_CONNECT')
                ctx.commit('setCount', ctx.state.count + 1)
              }, 2000)
            }
          }
        }

        socket.onerror = function (error) {
          console.error(error)
          bc.close()
        }
      }
    },
    SOCKET_SEND_MESSAGE(ctx, message) {
      if (ctx.state.connect) {
        socket.send(message)
      }
    },
    SOCKET_CLEAR(ctx) {
      ctx.commit('setMessages', null)
    },
    SOCKET_CLOSE() {
      socket.close()
      bc.close()
    },
  },
}
